import { createContext } from "react";

/**
 * Coordinates pause state between a carousel and its autoplay videos.
 *
 * - `null` (default) — no external controller. VideoPlayerControls shows
 *   its own play/pause button and manages playback independently.
 * - `true` / `false` — externally controlled. VideoPlayerControls hides
 *   its own play/pause button (the carousel's unified button handles it)
 *   and pauses/resumes the video accordingly.
 */
export const MotionPauseContext = createContext<boolean | null>(null);
